const USER_ORG_ROLES = {
  ALL: 'All',
  OWNER: 'Owner',
  ADMIN: 'Admin',
  MEMBER: 'Member',
}

export default USER_ORG_ROLES
